// removed by extract-text-webpack-plugin
module.exports = {"modalWrap":"overviewModal_modalWrap_3Mpyl","gradeBox":"overviewModal_gradeBox_aUDS5","grade":"overviewModal_grade_32yFY","tags":"overviewModal_tags_3IU2c","tagActive":"overviewModal_tagActive_3CZjH","titleTip":"overviewModal_titleTip_1Bjd9","chart":"overviewModal_chart_11g7-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/company/overviewModal.scss
// module id = 1559
// module chunks = 0